import { useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router';
import {
  COVENANTS_APPLICATION_CONTRAGENT_QUERY_PARAM,
  getPersistedCovenantsApplicationContragent,
  parsePositiveNumber,
  persistCovenantsApplicationContragent,
} from '~/modules/covenants/utils.ts';

export const useCovenantsApplicationContragent = ({
  applicationId,
  contragentId,
}: {
  applicationId?: string;
  contragentId?: number | string | null;
}) => {
  const navigate = useNavigate();
  const location = useLocation();

  const locationContragentId = parsePositiveNumber(
    (location.state as { contragentId?: number } | null)?.contragentId
  );
  const queryContragentId = parsePositiveNumber(
    new URLSearchParams(location.search).get(COVENANTS_APPLICATION_CONTRAGENT_QUERY_PARAM)
  );
  const persistedContragentId = getPersistedCovenantsApplicationContragent(applicationId);
  const currentContragentId =
    locationContragentId ||
    queryContragentId ||
    persistedContragentId ||
    parsePositiveNumber(contragentId);

  useEffect(() => {
    if (!applicationId || !currentContragentId) {
      return;
    }

    persistCovenantsApplicationContragent(applicationId, currentContragentId);

    const searchParams = new URLSearchParams(location.search);
    const currentSearchContragentId = parsePositiveNumber(
      searchParams.get(COVENANTS_APPLICATION_CONTRAGENT_QUERY_PARAM)
    );

    if (currentSearchContragentId === currentContragentId) {
      return;
    }

    searchParams.set(COVENANTS_APPLICATION_CONTRAGENT_QUERY_PARAM, String(currentContragentId));

    navigate(
      {
        pathname: location.pathname,
        search: `?${searchParams.toString()}`,
      },
      {
        replace: true,
        state: {
          ...((location.state as Record<string, unknown> | null) ?? {}),
          contragentId: currentContragentId,
        },
      }
    );
  }, [
    applicationId,
    currentContragentId,
    location.pathname,
    location.search,
    location.state,
    navigate,
  ]);

  return currentContragentId;
};
